import React, { useEffect, useState } from 'react';

import PaddedLoader from 'components/PaddedLoader';

import IconThumbnail from './IconThumbnail';

type Props = {
  filename: string | undefined | null;
  url: string;
  thumbnailUrl: string;
  disablePreview?: boolean;
};

function ImageThumbnail({ filename, url, thumbnailUrl, disablePreview = false }: Props) {
  const [backgroundImage, setBackgroundImage] = useState<string | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  const loadImage = () => {
    setIsLoading(true);
    const img = new Image();
    img.src = thumbnailUrl;
    img.onload = () => {
      setBackgroundImage(thumbnailUrl);
      setIsLoading(false);
    };
    img.onerror = () => {
      setIsLoading(false);
    };
  };

  useEffect(() => {
    loadImage();
  }, []);

  if (isLoading) {
    return (
      <div style={{ width: '100%', height: '100%' }}>
        <PaddedLoader />
      </div>
    );
  }

  return (
    <div
      className={!disablePreview ? 'cursor-pointer' : undefined}
      style={{ width: '100%', height: '100%' }}
      role="presentation"
    >
      {backgroundImage ? (
        <div
          style={{
            borderRadius: 3,
            width: '100%',
            height: '100%',
            background: `url(${backgroundImage})`,
            backgroundPosition: 'center center',
            backgroundSize: 'cover',
          }}
        />
      ) : (
        <span className="anchor">
          <IconThumbnail filename={filename} url={url} />
        </span>
      )}
    </div>
  );
}

export default ImageThumbnail;
